import { createFileRoute, redirect } from "@tanstack/react-router";

// The stories admin moved into the Intelligence Hub; keep old bookmarks working.
export const Route = createFileRoute("/admin/transformation-stories")({
  staticData: { title: "Success Stories" },
  beforeLoad: () => {
    throw redirect({ to: "/admin/cih/stories", replace: true });
  },
});
